import { render, staticRenderFns } from "./BrillerLogoBanner.vue?vue&type=template&id=08c19709&scoped=true"
import script from "./BrillerLogoBanner.vue?vue&type=script&lang=js"
export * from "./BrillerLogoBanner.vue?vue&type=script&lang=js"
import style0 from "./BrillerLogoBanner.vue?vue&type=style&index=0&id=08c19709&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c19709",
  null
  
)

export default component.exports